import * as React from 'react';
import { AppBar, TitlePortal } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { AppBarToolbar } from './AppBarToolbar';

const CustomAppBar = () => (
  <AppBar color="secondary" toolbar={<AppBarToolbar />}>
    <TitlePortal />
    <Box component="span" sx={{ flex: 1 }} />
    <Typography variant="body2" sx={{ mr: 2, display: { xs: 'none', sm: 'block' } }}>
      Marketing
    </Typography>
  </AppBar>
);

export default CustomAppBar;
